import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'installations',
});

export const installationDetailsRouteRef = createSubRouteRef({
  id: 'installation_detail',
  parent: rootRouteRef,
  path: '/:installation_id',
});

export const installationCreateRouteRef = createSubRouteRef({
  id: 'installation_create',
  parent: rootRouteRef,
  path: '/create',
});

export const installationCredentialsRouteRef = createSubRouteRef({
  id: 'installation_credentials',
  parent: rootRouteRef,
  path: '/:installation_id/credentials',
});

// revision installationCreateRouteRefs
//
//
//
export const installationRevisionViewRouteRef = createSubRouteRef({
  id: 'installation_revision_view',
  parent: rootRouteRef,
  path: '/:installation_id/revision/:revision',
});

export const installationRevisionsRouteRef = createSubRouteRef({
  id: 'installation_revisions',
  parent: rootRouteRef,
  path: '/:installation_id/revisions',
});

export const installationRevisionCompareRouteRef = createSubRouteRef({
  id: 'installation_revision_compare',
  parent: rootRouteRef,
  path: '/:installation_id/revisions/:revision1/:revision2',
});

export const allInstallationsRouteRef = createSubRouteRef({
  id: 'all_installations',
  parent: rootRouteRef,
  path: '/all',
});

export const allFlagsRouteRef = createSubRouteRef({
  id: 'all_flags',
  parent: rootRouteRef,
  path: '/all_flags',
});

export const flagStatisticsRouteRef = createSubRouteRef({
  id: 'flag_statistics',
  parent: rootRouteRef,
  path: '/flags/statistics',
});

// A root of its own rather than a sub-route: the Admin page is a sidebar entry
// beside Gate Configs, not a page under it.
export const adminRouteRef = createRouteRef({
  id: 'admin',
});
